import React, { useRef, useState, useEffect } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Link } from 'react-router-dom';
//no need of qr code 
import QRCode from 'react-qr-code';
import '../styleBusiness/business04.css'


// import img from '../Images/logo.jpeg'
import img from "../bigimg.png"


const Business04 = () => {

    const [cardWhatsApp, setcardWhatsApp] = useState();
    const [cardaddress, setcardaddress] = useState();
    const [cardcity, setcardcity] = useState();
    const [cardcompname, setcardcompname] = useState();
    const [cardcountry, setcardcountry] = useState();
    const [cardemail, setcardemail] = useState();
    const [cardfirstname, setcardfirstname] = useState();
    const [cardjobtitle, setcardjobtitle] = useState();
    const [cardlastname, setcardlastname] = useState();
    const [cardphone, setcardphone] = useState();
    const [cardpostcode, setcardpostcode] = useState();
    const [cardstate, setcardstate] = useState();
    const [cardtagline, setcardtagline] = useState();
    const [cardwebsite, setcardwebsite] = useState();
    const [Image, setImage] = useState();

    //QR code
    const [QRcode, setQRcode] = useState();

    const pdfRef = useRef();

    useEffect(() => {
        const businessCardObj = JSON.parse(localStorage.getItem("businessCardObj"));
        setcardWhatsApp(businessCardObj.cardWhatsApp);
        setcardaddress(businessCardObj.cardaddress);
        setcardcity(businessCardObj.cardcity);
        setcardcompname(businessCardObj.cardcompname);
        setcardcountry(businessCardObj.cardcountry);
        setcardemail(businessCardObj.cardemail);
        setcardfirstname(businessCardObj.cardfirstname);
        setcardjobtitle(businessCardObj.cardjobtitle);
        setcardlastname(businessCardObj.cardlastname);
        setcardphone(businessCardObj.cardphone);
        setcardpostcode(businessCardObj.cardpostcode);
        setcardstate(businessCardObj.cardstate);
        setcardtagline(businessCardObj.cardtagline);
        setcardwebsite(businessCardObj.cardwebsite);

        setImage(localStorage.getItem("profilePhoto"));
        // cardWhatsApp1 = cardWhatsApp;

        //QR code
        setQRcode(loadQRCode());
    }, []);

    const loadQRCode = () => {
    const businessCardObj = JSON.parse(localStorage.getItem("businessCardObj"));

        return (
            <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={"https://wa.me/+91" + businessCardObj.cardWhatsApp}
                bgColor="rgb(30,32,31)"
                fgColor="rgb(228,176,1)"
                viewBox={`0 0 256 256`}
            />
        );
    };


    const downloadImage = () => {

        document.getElementById('front04').style.marginBottom = "0px"
        document.getElementById('front04').style.marginTop = "0px"

        const table = document.getElementById('cardforntBack04');

        html2canvas(table).then(function (canvas) {
            const link = document.createElement('a');
            link.download = 'business.png';
            link.href = canvas.toDataURL('image/png');
            link.click();
        });

        document.getElementById('front04').style.marginBottom = "20px"
        document.getElementById('front04').style.marginTop = "40px"
    }

    const downloadPDF = () => {

        document.getElementById('front04').style.marginBottom = "0px"
        document.getElementById('front04').style.marginTop = "0px"



        const mybtn = document.getElementById("mybtn");
        mybtn.style.display = 'none';
        const input = pdfRef.current;
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a3', false);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
            const imgX = (pdfWidth - imgWidth * ratio) / 2;
            const imgY = 5;
            pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
            pdf.save('business.pdf')
            mybtn.style.display = 'block';
        });

        document.getElementById('front04').style.marginBottom = "10px"
        document.getElementById('front04').style.marginTop = "40px"



    }

    document.body.style = 'background: white;';



    return (
        <div className='container04'>
            <div id="cardforntBack04" ref={pdfRef}>
                <div className="front04" id='front04'>
                    <div className="containerTopFront04">
                        <div className="imgContainer04">
                            <img className='Image04' src={Image} alt="" />
                        </div>
                        <h2 className='title04'>{cardcompname}</h2>
                        <p className='tagline04'>{cardtagline}</p>
                    </div>
                    <div className='line04'></div>
                    <div className="containerBottomFront04">
                        <div>{cardwebsite}</div>
                    </div>
                </div>
                <div className="back04">
                    <div className="containerLeft04">
                        <div className="imgContainer004">
                            {/* <img className='Image004' src={Image} alt="" /> */}
                        {QRcode}
                        </div>
                    </div>
                    <div className="containerRigt04">
                        <div className="name_prof">
                            <h1 className='name04'><b>{cardfirstname}</b> {cardlastname}</h1>
                            <p className='jobtitle04'>{cardjobtitle}</p>
                        </div>
                        <div className="details04">
                            <div className="back02-details">
                                <ion-icon
                                    className="back02-icon"
                                    name="phone-portrait-outline"
                                ></ion-icon>
                                <p className="back02-detail02">
                                    {cardphone}
                                </p>
                            </div>
                            <div className="back02-details">
                                <ion-icon
                                    className="back02-icon"
                                    name="mail-outline"
                                ></ion-icon>
                                <p className="back02-detail02">
                                    {cardemail}
                                </p>
                            </div>
                            <div className="back02-details">
                                <ion-icon
                                    className="back02-icon"
                                    name="globe-outline"
                                ></ion-icon>
                                <p className="back02-detail02">
                                    {cardwebsite}
                                </p>
                            </div>
                            <div className="back02-details">
                                <ion-icon
                                    className="back02-icon"
                                    name="location-outline"
                                ></ion-icon>
                                <p className="back02-details02">
                                    {cardaddress},{cardcity}, {cardstate}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="line204"></div>
            </div>

            {/* buttons */}
            <div className="business01-btn-container">

               
                <button onClick={downloadImage} type="button" className="btn btn-success business03-btn">Download Image</button>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    fontFamily: "kanit",
                    marginBottom: "20px",
                }}
            ></div>
            <div style={{
                display: "flex",
                justifyContent: "center",
                fontFamily: "kanit",
                marginBottom: "20px",
            }}
            >
                <Link to="/business-3" class="btn btn-outline-danger" style={{ marginRight: "50px", width: "180px", fontSize: "18px" }}>
                    Back
                </Link>

                <Link to="/business-4" class="btn btn-outline-success" style={{ width: "180px", fontSize: "18px" }} >
                    Next
                </Link>
            </div>
        </div>
    )
}

export default Business04